// @ts-check

export const DEFAULT_LOCALE = 'en-gb';

export const languages = [
    {
        value: 'en-GB',
        label: 'English (European)',
        altCodes: ['en-IE', 'en-ie', 'en-gb'],
    },
    {
        value: 'en-US',
        label: 'English (USA)',
        altCodes: ['en-us', 'en'],
    },
    {
        value: 'fr',
        label: 'Français',
        altCodes: ['FR'],
    },
    {
        value: 'nl',
        label: 'Nederlands',
        altCodes: ['NL'],
    },
    {
        value: 'pt-PT',
        label: 'Português (Europeu)',
        altCodes: ['pt-pt'],
    },
    {
        value: 'es',
        label: 'Español',
        altCodes: ['ES'],
    },
    {
        value: 'de',
        label: 'Deutsche',
        altCodes: ['DE'],
    },
];

/**
 * Normalise a string to kebab-case
 *
 * TODO: possibly move to string utility file?
 *
 * @param {string} value
 * @returns {string}
 */
export function normalisedValue(value) {
    return String(value)
        .trim()
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
}

/**
 * Normalise a string to compatible language
 * code - if a dash exists, post-dash part is
 * uppercased.
 *
 * Not the prettiest code.
 *
 * @param {string} value
 * @returns {string}
 */
export function normalisedLanguageKey(value) {
    // eslint-disable-next-line no-param-reassign
    value = normalisedValue(value);
    if (!value.includes('-')) {
        return value;
    }
    const parts = value.split('-');
    parts[1] = parts[1].toUpperCase();
    return parts.join('-');
}

/**
 * Normalise given values to a unique
 * array of kebab-cased values
 *
 * TODO: possibly move to string utility file?
 *
 * @param {string[]} values
 * @returns {string[]}
 */
export function normalisedValues(values) {
    return [...new Set(values.map(normalisedValue))];
}

/**
 * Returns a map of locales
 *
 * TODO: with additional refactoring/moving languages into
 * this file, this function may not be needed
 *
 * @returns {Object<string, string[]>}
 */
export function localeMap() {
    return Object.fromEntries(languages.map(lang => [normalisedLanguageKey(lang.value), normalisedValues(lang.altCodes.concat(lang.value))]));
}

/**
 * Finds the locale from a given value
 *
 * @param {string} lang
 * @param {string | boolean} defaultValue
 * @returns {string | boolean}
 */
export function findLocale(lang, defaultValue = DEFAULT_LOCALE) {
    // eslint-disable-next-line no-param-reassign
    lang = normalisedValue(lang);
    // eslint-disable-next-line no-restricted-syntax
    for (const [locale, locales] of Object.entries(localeMap())) {
        if (locales.includes(lang)) {
            return locale;
        }
    }
    return defaultValue;
}

/**
 * Detects the locale from the browser
 *
 * @param {string | boolean} defaultValue
 * @returns {string | boolean}
 */
export function detectLocale(defaultValue = DEFAULT_LOCALE) {
    // @ts-ignore
    return findLocale(window.navigator.userLanguage || window.navigator.language, defaultValue);
}
